import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {IPaginateProducts} from 'src/shared/common-dtos/get-all-paginate';
import {
  PAGE_NUMBER,
  PRODUCT_NUMBER_IN_ONE_PAGE,
} from 'src/shared/constants/AppConst';
import {ISubscriberSearch} from 'src/shared/services/Subscribers/dto';

interface SubscriberInitialState {
  subscriberSearch: ISubscriberSearch;
  paginate: IPaginateProducts;
}

const initialState: SubscriberInitialState = {
  subscriberSearch: {
    SearchEmail: '',
    ActiveId: 0,
  },
  paginate: {
    Page: PAGE_NUMBER,
    PageSize: PRODUCT_NUMBER_IN_ONE_PAGE,
  },
};

const subscriberSlice = createSlice({
  name: 'subscriber',
  initialState: initialState,
  reducers: {
    setSubscriberSearch: (state, action) => {
      state.subscriberSearch = {...state.subscriberSearch, ...action.payload};
    },
    resetSubscriberSearch: (state) => {
      state.subscriberSearch = {
        ActiveId: 0,
        SearchEmail: undefined,
      };
    },
    onPaginateionSearch: (state) => {
      state.paginate = {
        ...state.paginate,
        Page: 1,
      };
    },
    onPaginateionChange: (state, action: PayloadAction<IPaginateProducts>) => {
      state.paginate = {
        Page: action.payload.Page,
        PageSize: action.payload.PageSize,
      };
    },
  },
});

export const {
  setSubscriberSearch,
  resetSubscriberSearch,
  onPaginateionChange,
  onPaginateionSearch,
} = subscriberSlice.actions;
export default subscriberSlice.reducer;
